import { Outlet } from "react-router-dom";

const HostelManagementMainPage = () => {
    return <Outlet />;
}

export default HostelManagementMainPage;